import script from "./bis-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./bis-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__